import Bowser from 'bowser';
import { SUPPORTED_BROWSERS } from '../constants';

// order matters
const browserKeys = [
  'Edge',
  'Trident',
  'MSIE',
  'Firefox',
  'OPR',
  'Chrome',
  'Safari',
  'Opera',
];
const ua = window.navigator.userAgent;

export const browserChecker = () =>
  browserKeys.find(key => ua.indexOf(key) > -1);

export const isSafari = () => browserChecker() === 'Safari';
export const isIE = () =>
  browserChecker() === 'MSIE' || browserChecker() === 'Trident';
export const isMS = isIE() || browserChecker() === 'Edge';

export function browserInfo() {
  return Bowser.getParser(window.navigator.userAgent);
}

export function isIOS() {
  return browserInfo().is('macOS');
}

export function isMobileIOS() {
  return browserInfo().is('iOS');
}

export function isAndroid() {
  return browserInfo().is('Android');
}

export function getBrowserName() {
  const parser = browserInfo();
  return parser.getBrowserName();
}

export function isSupportedBrowser() {
  const browserName = getBrowserName();
  const isSupported = SUPPORTED_BROWSERS.includes(browserName);
  return isIOS() ? true : isSupported;
}



// WEBPACK FOOTER //
// ./src/utils/browserChecker.js